<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div *ngIf="ImportLoading == true">
					<p-progressSpinner></p-progressSpinner>
				</div>

				<div *ngIf="ImportLoading == false">
					<!--Bus Table, Top-->
					<div class="BusDiv">
						<h4 *ngIf="Imported == false">Buses:</h4>
						<h4 *ngIf="Imported == true">
							Buses:
							<span style="color: blue">(Imported buses can only change description)</span>
						</h4>

						<caass-bus-maintenance-bus-table (SelectedBusChanged)="onSelectedBusChanged($event)"> </caass-bus-maintenance-bus-table>
					</div>

					<!--Bottom Tables-->
					<div class="BottomGrid2Col">
						<!--Route Table, Bottom Left-->
						<div class="BusDiv">
							<h4 *ngIf="Imported == false">Routes:</h4>
							<h4 *ngIf="Imported == true">
								Routes:
								<span style="color: blue">(Imported routes can only change description and comments)</span>
							</h4>

							<h4 *ngIf="SelectedBus != undefined">
								Bus:
								<span style="color: blue">{{ SelectedBus.BusNbr }}</span>
							</h4>

							<caass-bus-maintenance-route-table [SelectedBus]="SelectedBus" (SelectedRouteChanged)="onSelectedRouteChanged($event)">
							</caass-bus-maintenance-route-table>
						</div>

						<!--Student Table, Bottom Right-->
						<div class="BusDiv">
							<h4 *ngIf="Imported == false">Students on Route:</h4>
							<h4 *ngIf="Imported == true">
								Students on Route:
								<span style="color: blue">(Imported students can't be removed)</span>
							</h4>

							<h4 *ngIf="SelectedRoute != undefined">
								Route:
								<span style="color: blue">{{ SelectedRoute.BusRouteNbr }} {{ SelectedRoute.BusRouteTypeDesc }}</span>
							</h4>

							<caass-bus-maintenance-student-table [SelectedRoute]="SelectedRoute"> </caass-bus-maintenance-student-table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
